/* eslint-disable @typescript-eslint/ban-ts-comment */
import { store } from '@/store';
import { BaseCompoundFormFieldBuilder } from '.';
import { DateRangeFormField, FormFieldType } from '../typings';
import { setConditionalParentFields } from '../store';

export class DateRangeFormFieldBuilder extends BaseCompoundFormFieldBuilder<DateRangeFormField> {
  protected _type = FormFieldType.DateRange;
  protected _typeValue = FormFieldType.DateRange;
  // @ts-ignore
  private _fields: DateRangeFormField['fields'] = [];

  constructor() {
    super();
  }

  public fields(value: DateRangeFormField['fields']): this {
    this._fields = [...value];

    const childrenIds = this._fields.map(child => child.fieldId);

    store.dispatch(
      setConditionalParentFields({
        [this._fieldId]: childrenIds,
      }),
    );

    return this;
  }

  // TODO: Add methods to add from and to single fields
}
